// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // MUI Icon
// import React from "react";

// const CopyLinkModal = ({ link, showModal, setShowModal }) => {
//   // const [showModal, setShowModal] = useState(false);
//   // const [link] = useState("https://example.com");

// const handleCopy = () => {
//   navigator.clipboard.writeText(link);
// };

//   return (
//     <div className="flex items-center justify-center h-screen bg-gray-50">

//       { showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10">
//           <div className="bg-white p-6 rounded-md shadow-lg max-w-sm w-full mx-4">
//             {/* Modal Header */ }
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-2">
//                 <CheckCircleIcon style={ { color: "#4caf50" } } />
//                 <h3 className="text-gray-800 font-semibold">Your Link</h3>
//               </div>
//               {/* Close Modal Button */ }
//               <button
//                 onClick={ () => setShowModal(false) }
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 &times;
//               </button>
//             </div>

//             {/* Link Display */ }
//             <p className="text-gray-600 text-sm mb-4 break-words">{ link }</p>

//             {/* Copy Button */ }
//             <button
//               onClick={ handleCopy }
//               className="text-sm bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-4 rounded-md transition-all duration-200"
//             >
//               Copy Link
//             </button>
//           </div>
//         </div>
//       ) }
//     </div>
//   );
// };

// export default CopyLinkModal;



import copy from 'copy-to-clipboard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const CopyLinkModal = ({ link, showModal, setShowModal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const handleCopy = (linkView) => {
    copy(linkView);
    toast.success(t('Link copy Successfully'));
    setShowModal(false)
    navigate('/donorLogin');

  };
  return (
    <>
      { showModal ? (
        <>
          <div className="modal-overlay justify-star items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto mx-auto max-w-3xl">
              <div className="relative font-inter antialiased">
                <main className="relative min-h-screen flex flex-col justify-center overflow-hidden">
                  <div className="w-full max-w-6xl mx-auto px-4 md:px-6 ">
                    <div className="flex justify-center">
                      <div className="max-w-md mx-auto text-center bg-white text-black px-4 sm:px-8 pb-4 rounded-xl shadow">
                        <header className="">
                          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            { ' ' }
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />{ ' ' }
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                          </svg>
                          {/* Link Display */ }
                          <p className="text-black text-sm my-4 ">{ link }</p>

                          {/* Copy Button */ }
                          <button
                            onClick={ () => handleCopy(link) }
                            className="text-sm bg-gray-100 hover:bg-customgreen text-gray-800 hover:text-white py-2 px-4 rounded-md transition-all duration-200"
                          >
                            {t("Copy Activation Link")}
                          </button>
                        </header>
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null }
    </>
  );
};

export default CopyLinkModal;

